import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { MixpanelContext } from '../context/MixpanelContext';
import { TrackAction } from '../../../../lib/mixpanel';
import { COPIES_PREFIX } from '../constants';
import { Actions } from './Actions';
import type { MediaPreviewProps } from './types';

import classes from './MediaPreview.module.scss';

export const MediaPreview = ({ id, isVideo, src }: MediaPreviewProps) => {
  const track = useContext(MixpanelContext);

  const onPlay: React.ReactEventHandler<HTMLVideoElement> = () => track(TrackAction.Play);

  const onPause: React.ReactEventHandler<HTMLVideoElement> = () => track(TrackAction.Pause);

  const soundOnRef = useRef(false);
  const onVolumeChange: React.ChangeEventHandler<HTMLVideoElement> = ({ target }) => {
    const { muted, volume } = target;
    const soundOn = !muted && volume > 0;
    if (soundOn !== soundOnRef.current) {
      track(soundOn ? TrackAction.SoundOn : TrackAction.SoundOff);
      soundOnRef.current = soundOn;
    }
  };

  const textImageAlt = translate(`${COPIES_PREFIX}.image_preview_alt`);

  return (
    <div className={classnames(classes.container, 'flex flex-center flex-items-center')}>
      {isVideo && (
        <video
          className={classes.video}
          onPlay={onPlay}
          onPause={onPause}
          onVolumeChange={onVolumeChange}
          src={src}
          controls
          autoPlay
          muted
        />
      )}
      {!isVideo && <img className={classes.image} src={src} alt={textImageAlt} />}
      <div className={classes.actions}>
        <Actions id={id} />
      </div>
    </div>
  );
};
